import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["track"]

  connect() {
    this.speed = 0.5
    this.paused = false
    this._scroll = this._scroll.bind(this)

    const track = this.trackTarget
    const childCount = track.children.length

    // Only duplicate and scroll if there's more than 1 item
    if (childCount <= 1) return

    const original = track.innerHTML
    track.innerHTML = original + original

    this._halfHeight = track.scrollHeight / 2

    this.element.addEventListener("mouseenter", () => this.paused = true)
    this.element.addEventListener("mouseleave", () => this.paused = false)

    requestAnimationFrame(this._scroll)
  }

  disconnect() {
    this.paused = true
  }

  _scroll() {
    if (!this.paused && this.hasTrackTarget) {
      const track = this.trackTarget
      track.scrollTop += this.speed

      // When we've scrolled past the first copy, jump back seamlessly
      if (track.scrollTop >= this._halfHeight) {
        track.scrollTop -= this._halfHeight
      }
    }

    requestAnimationFrame(this._scroll)
  }
}
